module.exports = __webpack_public_path__ + "static/img-main-8c3eba08d5dc0c061c024f9d268f0bf6.jpg";